import * as React from 'react';
import { useContext, useMemo } from 'react';
import Footer from '@search/vtbeco-frontend-core/view/common/components/Footer';
import { DATA_GTM } from '@search/vtbeco-frontend-core/domain/newbuilding/libs/constants';
import { isSpbWide } from '@search/helpers/src/isRegion';

import {
    IOnChangeGlobalContext,
    OnChangeGlobalContext
} from '../../../../../client/common/components/GlobalContext';

const FOOTER_PHONE_SPB = '+7 812 317 00 26';
const FOOTER_PHONE_MSK = '+7 499 288 89 62';

const getFooterPhone = (regionId?: number): string => {
    if (! regionId) {
        return FOOTER_PHONE_MSK;
    }

    if (isSpbWide(regionId)) {
        return FOOTER_PHONE_SPB;
    }

    return FOOTER_PHONE_MSK;
};

export default ({ regionId }: { regionId?: number }) => {
    const onChangeGlobalContext = useContext<IOnChangeGlobalContext>(OnChangeGlobalContext);

    const phone = useMemo(() => ({
        phoneNumber: getFooterPhone(regionId),
        analytics: DATA_GTM.FOOTER_PHONE
    }), [ regionId ]);

    return (
        <Footer
            buildLink={onChangeGlobalContext.linkBuilder.external}
            phone={phone}
            regionId={regionId}
        />
    );
};
